<script setup lang="ts">
  import VerificationTable from '../VerificationTable.vue';
  import VerificationListView from './VerificationListView.vue';
</script>

<template>
  <VerificationListView :table-component="VerificationTable" />
</template>
